import { render, staticRenderFns } from "./MultivariateAnalysis.vue?vue&type=template&id=58038c24&"
import script from "./MultivariateAnalysis.script.js?vue&type=script&lang=js&"
export * from "./MultivariateAnalysis.script.js?vue&type=script&lang=js&"
import style0 from "./MultivariateAnalysis.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports